import { BeckyModel, BeckyRequestPayload } from '@wix/thunderbolt-becky-root'
import { FetchFn } from '@wix/thunderbolt-becky-types'

type WidgetData = {
	appDefinitionId: string
	widgetId: string
}

const REQUEST_ID_HEADER = 'X-Wix-Request-Id'
const SA_DATA_GROUPS = /(metaSiteId=(.*?)&)|(siteId=(.*?)&)|(siteRevision=(.*?)$)/g
const extractSAData = (siteAssetUrl: string) => {
	const [siteIdGroup, metaSiteIdGroup, siteRevisionGroup] = [...siteAssetUrl.matchAll(SA_DATA_GROUPS)]
	return {
		siteId: siteIdGroup[4],
		metaSiteId: metaSiteIdGroup[2],
		siteRevision: siteRevisionGroup[6],
	}
}
export const createPresetsSiteAssetsClient = async (
	payload: BeckyRequestPayload,
	beckyModel: BeckyModel,
	fetchFn: FetchFn,
	{ appDefinitionId, widgetId }: WidgetData
) => {
	const appData = Object.values(beckyModel.clientSpecMap).filter((app) => app.appDefinitionId === appDefinitionId)[0]!
	const widgetData = Object.values(appData.widgets!).filter((widget) => widget.widgetId === widgetId)[0]!
	const pageId = widgetData.componentFields.appStudioFields!.id!
	const { metaSiteId, siteId, siteRevision } = extractSAData(appData.appFields.platform.baseUrls.siteAssets)

	const widgetPresetsPayload = {
		...payload,
		metaSiteId,
		pageId,
		siteId,
		// fileId,
		siteRevision,
		shouldSplitByPresets: 'true',
	}

	const baseSAUrl = 'https://siteassets.parastorage.com'

	const queryParamsList = []
	for (const paramKey in widgetPresetsPayload) {
		// @ts-ignore
		if (typeof widgetPresetsPayload[paramKey] === 'string') {
			// @ts-ignore
			queryParamsList.push(`${paramKey}=${encodeURIComponent(widgetPresetsPayload[paramKey])}`)
		}
	}
	const queryParams = queryParamsList.join('&')

	// setting directly the themeOverride without encodeURIComponent since it's encoding the value, and it's not supposed to
	const requestUrl = `${baseSAUrl}/pages/pages/thunderbolt?${queryParams}`

	return fetchFn(requestUrl).then((res) => {
		const requestId = res?.headers?.get?.(REQUEST_ID_HEADER)
		if (!res.ok) {
			return res.text().then((message) => {
				throw new Error(
					`Failed to fetch builder CSS. requestId: ${requestId}. status code: ${res.status}. Original Error: ${message}`
				)
			})
		}
		return res.json().catch((e) => {
			throw new Error(`Failed to fetch builder CSS. requestId: ${requestId}. Original Error: ${e.message}`)
		})
	})
}
